import React, { FunctionComponent, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import styles from './styles.module.scss';

type Props = {
  className?: string;
  activeClassName?: string;
  to: string;
  rawLink?: boolean;
  openNewWindow?: boolean;
  variant?: 'default' | 'primary' | 'minimal';
  exact?: boolean;
  download?: string;
} & (
  | {
      // either label or children should be defined
      label: string;
      children?: undefined;
    }
  | {
      label?: undefined;
      children: ReactNode;
    }
);

export const LinkButton: FunctionComponent<Props> = ({
  className,
  activeClassName,
  label,
  children,
  to,
  rawLink,
  openNewWindow,
  variant,
  exact,
  download,
}) => {
  const linkProps = {
    className: classNames(
      styles.button,
      variant === 'primary' && styles.primary,
      variant === 'minimal' && styles.minimal,
      className,
    ),
    target: openNewWindow ? '_blank' : undefined,
  };

  return rawLink ? (
    <a {...linkProps} href={to} download={download}>
      {label ?? children}
    </a>
  ) : (
    <NavLink
      {...linkProps}
      activeClassName={activeClassName || 'active'}
      to={to}
      exact={exact}
    >
      {label ?? children}
    </NavLink>
  );
};
